/// <amd-module name="VSS/Features/ReduxDirectory/ConnectedDirectoryContentView" />
export * from "./components/DirectoryContentView/index";
